import http from 'plugins/axios';

export default {
  getTicketList(data) {
    return http.get({
      url: '/admin/workorder/search',
      data
    });
  },
  getTicketDetail(id) {
    return http.get({
      url: `/admin/workorder/detail/${id}`
    });
  },
  updateTicket(data) {
    return http.post({
      url: '/admin/workorder/update',
      data
    });
  },
  getTicketDialogue(id) {
    return http.get({
      url: `/admin/workorder/searchReply/${id}`
    });
  },
  createTicketDialogueReply(data) {
    return http.post({
      url: '/admin/workorder/addReply',
      data
    });
  }
};
